
export const INVALID_CODES = {
    REQUIRED: "required",
    MAX: "max",
    MIN: "min",
    INVALID_FORMAT: "invalid_format",
    DUPLICATE: "duplicate",
};
